namespace $ {

	self.addEventListener( 'storage' , event => $.$mol_state_local.changes( event ) )

}
